function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 165,
  cy: 165,
  r: 140,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M165 330a165.002 165.002 0 00161.83-197.19A165.007 165.007 0 00197.19 3.17 165 165 0 10165 330zm-64.63-206.67c0-5.07-.32-10-.79-15.06h22.67l.79 10.31c2.54-3.49 8.72-12 24.74-12 18.39 0 23.62 11.26 25.21 15.06 6.66-12.84 17.44-14.9 25.68-14.9 16.17 0 22.67 9.67 24.42 12.84 4.28 7 4 16.65 4 23.62V187h-23.66v-45.75c0-8.56-1.27-18.07-13.48-18.07-14.11 0-14.43 13.16-14.43 25V187H151.9v-46.22c0-6.19-.16-17.6-13.16-17.6-14.74 0-14.74 12.68-14.74 18.07V187h-23.63v-63.67zm-.79 81.29h127.47v19.5H99.58v-19.5zM165 302.71a137.714 137.714 0 01-127.22-85.016A137.717 137.717 0 0167.62 67.62a137.721 137.721 0 01194.76 194.76A136.819 136.819 0 01165 302.71zm0-256.34A118.629 118.629 0 10283.63 165 118.767 118.767 0 00165 46.37z",
  fill: "#020202"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h330v330H0z"
})));

function SvgVMta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 330,
    height: 330,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVMta);
export default __webpack_public_path__ + "static/media/vMTA.1b5a740a.svg";
export { ForwardRef as ReactComponent };